import styled from '@emotion/styled';
import { StaticImage } from 'gatsby-plugin-image';
import { h3, h4, smTxt } from './layout/styles/Typography';
import { px } from './layout/styles/classes';

const Section = styled.section`
    margin-top: 50px;

    > .gatsby-image-wrapper {
        height: 375px;

        img {
            object-position: top center;
        }
    }

    @media (min-height: 660px) {
        > .gatsby-image-wrapper {
            height: 440px;
        }
    }

    @media (min-width: 1024px) {
        margin-top: 58px;
    }

    @media (min-width: 1280px) {
        margin-top: 70px;
    }

    @media (min-width: 1600px) {
        > .gatsby-image-wrapper {
            height: 480px;
        }
    }
`;

const Box = styled.div`
    ${px};
    max-width: 1312px;
    box-sizing: content-box;
    margin: 40px auto 0;

    > h1 {
        ${h3};
        color: ${({ theme }) => theme.colors.black};
        margin: 8px 0;
    }

    > p {
        :first-of-type {
            ${h4};
            color: ${({ theme }) => theme.colors.primary};
            margin: 0;
            font-weight: 600;
        }

        :last-of-type {
            ${smTxt};
            margin: 0;
            color: ${({ theme }) => theme.colors.gray};

            > span {
                font-weight: 500;
            }
        }
    }
`;

type BlogHeroProps = {
    title: string;
    categories?: string;
};

export const BlogHero = ({ title, categories }: BlogHeroProps) => {
    return (
        <Section>
            <StaticImage
                src="../../assets/images/default-hero.jpg"
                alt="mountain"
                loading="eager"
                layout="fullWidth"
            />
            <Box>
                <p>Blog</p>
                <h1>{title}</h1>
                {categories ? <p> {categories}</p> : ''}
            </Box>
        </Section>
    );
};
